<div class="hitbox" part="hitbox">
  <ui-icon fitted icon="menu"></ui-icon>
</div>
